import { Platform } from '@angular/cdk/platform';
import { Injectable } from '@angular/core';
import { MemoryStorage } from './memory-storage';

@Injectable({
  providedIn: 'root',
})
export class SessionStorageService implements Storage {
  private readonly sessionStorage: Storage;

  constructor(private platform: Platform) {
    if (this.platform.isBrowser && window?.sessionStorage) {
      this.sessionStorage = window.sessionStorage;
    } else {
      this.sessionStorage = new MemoryStorage();
    }
  }

  get length(): number {
    return this.sessionStorage.length;
  }

  clear(): void {
    this.sessionStorage.clear();
  }

  getItem(key: string): string | null {
    return this.sessionStorage.getItem(key);
  }

  key(index: number): string | null {
    return this.sessionStorage.key(index);
  }

  removeItem(key: string): void {
    this.sessionStorage.removeItem(key);
  }

  contains(key: string): boolean {
    return this.sessionStorage.getItem(key) !== null;
  }

  setItem(key: string, value: string): void {
    this.sessionStorage.setItem(key, value);
  }
}
